import React, { useEffect, useState } from "react";
import { incrementPlayerField } from "../firebase/fireFuncs";
import MainStore from "../stores/MainStore";

const useTimer = () => {
  const { player } = MainStore();
  const [allTime, setAllTime] = useState(0);
  const [tick, setTick] = useState(0);
  const [smallTick, setSmallTick] = useState(0);
  const [timedFunctions, setTimedFunctions] = useState([]);

  function addTimedFunction(timedFunction) {
    const newArray = [...timedFunctions, timedFunction];
    setTimedFunctions(newArray);
  }

  useEffect(() => {
    if (smallTick % 5 == 0) setTick((state) => state + 1);
  }, [smallTick]);

  useEffect(() => {
    function addTick() {
      setSmallTick((state) => state + 1);
    }
    const interval = setInterval(addTick, 200);
    return () => clearInterval(interval);
  }, []);

  return { tick, smallTick, addTimedFunction };
};

export default useTimer;
